import React, {useState, useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import LogosCampanha from '../../comps/LogosCampanha/LogosCampanha';
import Contador from '../../comps/contador/Contador';
import CampanhaService from '../../services/CampanhaService';
import {Link} from 'react-router-dom';
import {useStore} from 'react-redux';
import TemaService from '../../services/TemaService'

function Home() {
    const campanhaService = new CampanhaService()
    const history = useHistory()
    const i18n = useStore().getState().i18n; 
    const [campanha] = useState(campanhaService.campanhaCorrente())
    

    const meses = i18n.meses()

    useEffect(() => {
        let temaService = new TemaService(campanhaService.campanhaCorrente())
        temaService.aplicarTema('ESPERA')

        campanhaService.contadorCampanha((erro, sucesso)=>{
            if(erro){
                return erro
            }
            if(sucesso){
                if(sucesso !== null){
                    if(sucesso.length > 0 ){
                        history.push('/atividades')
                    }
                }
            }
        })

    },[])
    
    let data = campanha.startDate.split("/")
    let horas = data[2].split(" ")
    data[2] = horas[0]
    horas = horas[1].split(":")
    const inicio = data[0] + " DE " + meses[parseInt(data[1]) - 1]

    const inicioCampanhaContador = new Date(parseInt(data[2]), parseInt(data[1]) - 1, parseInt(data[0]), parseInt(horas[0]), parseInt(horas[1]), parseInt(horas[2])).getTime()


    return (
        <div className="pagina-contador">
            <div
            className={
                campanha.preEventStartDate !== null
                    ? "info-campanha-container-interesse"
                    : "info-campanha-container"
            }
            >
                <LogosCampanha campanha={campanha}/>
                <br/>
                <span className="info-campanha-container__span foreground">{i18n.message("home.datainicio", "SEU EVENTO COMEÇARÁ")}</span> <br/>
                <span className="info-campanha-container__span info-campanha-container__span__data foreground">{inicio}</span>
            </div>
            <div
                className={
                    campanha.preEventStartDate !== null
                        ? "contador-campanha-container-interesse"
                        : "contador-campanha-container"
                }
            >
                <div>
                    <Contador inicioCampanha={inicioCampanhaContador}></Contador>
                </div>

                <div className="selecao-de-interesses">
					{campanha.preEventStartDate !== null &&
					campanha.preEventEndDate !== null ? (
						<Link to="/interests" className="button">
							{i18n.message("home.interesse.definir", "DEFINA SEUS INTERESSES")}
						</Link>
					) : null}
				</div>

                <div className="contador-campanha-container__link" style={{textAlign:'center'}}>
                    <Link to="/atividades" className="button">{i18n.message("home.instrucoes", "CONFIRA COMO FUNCIONA")}</Link>
                </div>
            </div>
        </div>
    )
}

export default Home;
